// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story"}[chunkId] || chunkId) + "-" + {"2813":"317423ac01958dd3b14b","3093":"edce189a8b15f2006fdc","3180":"b4439e63277f46397e76"}[chunkId] + ".css";
};